import styled from 'styled-components';
import { boxSizingKeys, boxSizingMixin, fullHeightKeys, fullHeightMixin, fullWidthKeys, fullWidthMixin, marginKeys, marginMixin, paddingKeys, paddingMixin, sizeKeys, sizeMixin } from '../mixins/layout';
import { withOmitProps } from '../helpers/elements';
import { positionKeys, positionMixin } from '../mixins/position';
import { backgroundColorKeys, backgroundColorMixin } from '../mixins/color';
import { borderRadiusKeys, borderRadiusMixin } from '../mixins/border';
import { styleForBreakpoints } from '../helpers/media-style';
const Box = styled.div.withConfig(withOmitProps(['inline', ...boxSizingKeys, ...fullWidthKeys, ...fullHeightKeys, ...sizeKeys, ...marginKeys, ...paddingKeys, ...positionKeys, ...backgroundColorKeys, ...borderRadiusKeys]))`
  ${({
  inline = false
}) => styleForBreakpoints(inline, inline => `display: ${inline ? 'inline-block' : 'block'};`)}
  ${backgroundColorMixin}
  ${borderRadiusMixin}
  ${boxSizingMixin}
  ${fullWidthMixin}
  ${fullHeightMixin}
  ${sizeMixin}
  ${marginMixin}
  ${paddingMixin}
  ${positionMixin}
`;
export default Box;